(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dx-utils", [], factory);
	else if(typeof exports === 'object')
		exports["dx-utils"] = factory();
	else
		root["dx-utils"] = factory();
})(window, function() {
return 